import { render, staticRenderFns } from "./TableArquivosEnviados.vue?vue&type=template&id=870208bc&scoped=true&"
import script from "./TableArquivosEnviados.vue?vue&type=script&lang=js&"
export * from "./TableArquivosEnviados.vue?vue&type=script&lang=js&"
import style0 from "./TableArquivosEnviados.vue?vue&type=style&index=0&id=870208bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870208bc",
  null
  
)

export default component.exports